import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

export interface MessageData {
  message?: string;
  type?: 'success' | 'warning' | 'alert';
}

export interface MessageSubject {
  id?: string;
  data?: MessageData;
  isVisible?: boolean;
  hideAll?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class MessageService {
  state$: Observable<MessageSubject>;
  private state: Subject<MessageSubject> = new Subject<MessageSubject>();

  constructor() {
    this.state$ = this.state.asObservable();
  }

  hide(id: string) {
    this.state.next({ id: id, isVisible: false });
  }

  hideAll() {
    this.state.next({ hideAll: true });
  }

  show(id: string, data: MessageData) {
    this.state.next({
      id: id,
      isVisible: true,
      data: data
    });
  }
}
